

export const path ="https://orientaloutsourcing.in/agilityconsulting/wp-json/";

